export enum WEBVIEW_TYPE {
  WELLO_APP = 'wello',
  KB_PAY = 'kbpay',
  TOSS = 'toss',
  KAKAOBANK = 'kakaobank',
}

const KB_WEBVIEW_USER_AGENT_PATTERN = /liivmate|kbpayia/i;

//! 카뱅 연동 규격 미수령 — 실제 웹뷰 UA 확인 후 패턴 확정 필요
const KAKAOBANK_WEBVIEW_USER_AGENT_PATTERN = /kakaobank/i;

export const detectWebviewType = (
  userAgent: string,
): WEBVIEW_TYPE | undefined => {
  if (userAgent.includes('welfarehello')) {
    return WEBVIEW_TYPE.WELLO_APP;
  }
  if (KB_WEBVIEW_USER_AGENT_PATTERN.test(userAgent)) {
    return WEBVIEW_TYPE.KB_PAY;
  }
  if (userAgent.includes('Toss')) {
    return WEBVIEW_TYPE.TOSS;
  }
  if (KAKAOBANK_WEBVIEW_USER_AGENT_PATTERN.test(userAgent)) {
    return WEBVIEW_TYPE.KAKAOBANK;
  }

  return undefined;
};
